import { Component } from '@angular/core';
import { AdvanceDashboardService } from '../dashboard.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NavbarService } from 'src/app/core/navigation/navbar/services/navbar.service';
import { NavigationService, ROUTE_METADATA } from 'src/app/core/navigation/services/navigation.service';
import { Subject } from 'rxjs';
import { RouteConfigService } from 'src/app/routing/route-config.service';
import { BaseService } from 'src/app/services/base.service';

@Component({
	selector: 'app-dashboards',
	templateUrl: './dashboards.component.html',
	styleUrl: './dashboards.component.scss',
	standalone: false,
})
export class DashboardsComponent {
	title = 'DashboardAngularApp';
	dashboardId: string = '';
	eventsSubjectdashboard: Subject<string> = new Subject<string>();

	DevExpressApiUrl = '';
	apiHeader: {};
	constructor(
		private baseService: BaseService,
		private location: Location, private navLocation: NavbarService, private navigationService: NavigationService,
		private route: ActivatedRoute, private dashboardService: AdvanceDashboardService
	) {
		let isAccessable = false;
		this.route.paramMap.subscribe(params => {
			const titleString = this.location.path(true).toString().lastIndexOf('/');
			// Slice the string to remove the last segment
			const currentPath = this.location.path(true).toString().slice(0, titleString);

			try {
				let item = this.navLocation.allUrlRawData.find(x => x.path?.toString().toLowerCase().includes(currentPath.toLowerCase()) && x.isActive)
				if (item) {
					if (this.baseService.getNewOptions() != null && this.baseService.getNewOptions().headers != null) {
						this.apiHeader = this.baseService.getNewOptions().headers;
					}
					this.loadPageload();
					isAccessable = true;
				}
			} catch (ex) {
				console.log(ex);
			}


		});

		if (!isAccessable) {
			navigationService.navigate(ROUTE_METADATA.NotFound);
		}
	}

	ngOnInit(): void {
	}

	loadPageload() {
		try {
			if (this.location.path(true) != null) {
				let items = this.location.path(true).split('/');
				let nextId = false;
				items.forEach((element) => {
					if (nextId) {
						this.dashboardService.GetDashboardMenus(
							element,
							{
								showLoadingIndicator: true,
							},
						).subscribe(
							(dashboardData) => {
								if (dashboardData?.table && dashboardData.table.length > 0 && dashboardData.table[0].menuIcon) {
									this.IsEnableCache = dashboardData.table[0].isEnableCache;
								}

								this.dashboardId = element;
							},
							(error: any) => { },
						);

						nextId = false;
					}

					if (element == 'dashboards') {
						nextId = true;
					}
				});
			}

			this.route.paramMap.subscribe(params => {
				this.title = params.get('name'); // Get the value of 'param2'
			});
			this.DevExpressApiUrl = this.baseService.getCorrectUrl("dashboard");
		} catch (ex) {

		}
	}

	IsEnableCache: boolean = false;
}